<template>
<div class="TVChartContainer" :id="containerId" />
</template>

<script>

import { widget } from '../../../public/charting_library';
import { JsapiObj } from './jsapi';

function getLanguageFromURL() {
  const regex = new RegExp('[\\?&]lang=([^&#]*)');
  const results = regex.exec(window.location.search);
  return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export default {
  //属性
  name: 'TVChartContainer',
  props: {
    symbol: {
      default: 'Coinbase:BTC/USD',
      type: String,
    },
    interval: {
      default: '15',
      type: String,
    },
    containerId: {
      default: 'tv_chart_container',
      type: String,
    },
    datafeedUrl: {
      default: 'https://demo_feed.tradingview.com',
      type: String,
    },
    libraryPath: {
      //default: '/charting_library/',
      default: './charting_library/',
      type: String,
    },
    fullscreen: {
      default: false,
      type: Boolean,
    },
    autosize: {
      default: true,
      type: Boolean,
    },
    studiesOverrides: {
      type: Object,
    }
  },
  tvWidget: null,
  mounted() {
    const widgetOptions = {
      debug: true,
      //debug:true,
      symbol: this.symbol,
      // BEWARE: no trailing slash is expected in feed URL
      //datafeed: new window.Datafeeds.UDFCompatibleDatafeed(this.datafeedUrl),
      datafeed:new JsapiObj(),
      theme: 'DARK',
      custom_css_url: 'custom_css/override.css',
      interval: this.interval,
      container: this.containerId,
      library_path: this.libraryPath,

      locale: getLanguageFromURL() || 'zh',
      fullscreen: this.fullscreen, 
      autosize: this.autosize,
      studies_overrides: this.studiesOverrides,
      toolbar_bg: '#161d31', // '#272b35', //背景色
      loading_screen: { backgroundColor: '#161d31' }, // loading背景色
      overrides: {
        'paneProperties.background': '#161d31', // 'rgba(39,43,53,1)', //'#272b35', // チャート背景色
        'paneProperties.backgroundGradientStartColor': '#161d31',
        'paneProperties.backgroundGradientEndColor': '#161d31',
      }
    };

    const tvWidget = new widget(widgetOptions);
    this.tvWidget = tvWidget;

    tvWidget.onChartReady(() => {
      tvWidget.headerReady().then(() => {
        const button = tvWidget.createButton();

        button.setAttribute('title', 'Click to show a notification popup');
        button.classList.add('apply-common-tooltip');

        button.addEventListener('click', () => tvWidget.showNoticeDialog({
            title: 'Notification',
            body: 'TradingView Charting Library API works correctly',
            callback: () => {
              // eslint-disable-next-line no-console
              console.log('Noticed!');
            },
          }));

        button.innerHTML = 'Check API';
      });
    });
  },
  destroyed() {
    if (this.tvWidget !== null) {
      this.tvWidget.remove();
      this.tvWidget = null;
    }
  }
}
</script>

<style lang="scss" scoped>
.TVChartContainer {
  height: calc(85vh);
}
</style>
